
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/white-papers/[slug]",
      function () {
        return require("private-next-pages/white-papers/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/white-papers/[slug]"])
      });
    }
  